import SparkMD5 from "spark-md5";
import { mapGetters } from "vuex";
import Opration from "./number_opration.js";
export default {
  computed: {
    ...mapGetters(["userInfo"])
  },
  mixins: [Opration], // 解决精度丢失的问题
  data() {
    return {
      // 日期选择器配置
      globalPickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    alert(payload = {}, type = "warning", title = "提示") {
      let msg = (payload.data && payload.data.msg) || payload.msg;
      if (typeof payload === "string") {
        msg = payload;
      }
      if (!msg) {
        // debugger//保留debugger，方便追踪异常原因
        switch (type) {
          case "info":
            msg = "";
            if (!title) title = "提示信息";
            break;
          case "waning":
            msg = "警告！";
            if (!title) title = "警告";
            break;
          case "success":
            msg = "处理成功";
            if (!title) title = "成功";
            break;
          case "error":
            msg = "处理失败";
            if (!title) title = "错误";
        }
        if (type === "error" && msg === "处理失败") return;
      }
      return this.$alert(msg, title, {
        type
      });
    },
    $error(payload, title) {
      console.log(payload);
      return this.alert(payload, "error", title);
    },
    $success(payload, title) {
      return this.alert(payload, "success", title);
    },
    $warning(payload, title) {
      return this.alert(payload, "warning", title);
    },
    $info(payload, title) {
      return this.alert(payload, "info", title);
    },
    $md5(model) {
      return SparkMD5.hash(JSON.stringify(model));
    },
    $handleErrorObject(o) {
      let msg = "";
      let kSet = Object.keys(o);
      if (kSet && kSet.length) {
        // 只展示第一条错误信息
        msg = o[kSet[0]][0].message;
        this.$message.warning(msg);
      } else {
      }
    },
    $print(id, model, action, method = "post") {
      let form = document.getElementById(id);
      if (!form) {
        // 创建form对象
        form = document.createElement("form");
        form.id = id;
        form.action = action;
        form.method = method;
        form.target = "_blank";
        document.body.appendChild(form);
      }
      Object.keys(model).forEach(k => {
        let input = form[k];
        if (!input || typeof input !== "object") {
          // 当k是一些特殊字符串时，name id之类的 input类型应该是string
          input = document.createElement("input");
          input.type = "hidden";
          input.name = k;
          form.appendChild(input);
        }
        if (model[k] === undefined) {
          input.value = "";
        } else {
          input.value = JSON.stringify(model[k]);
        }
      });
      form.submit();
    },
    // 打印传一个参数不需要加string时调用
    $printNoString(id, model, action, method = "post") {
      let form = document.getElementById(id);
      if (!form) {
        // 创建form对象
        form = document.createElement("form");
        form.id = id;
        form.action = action;
        form.method = method;
        form.target = "_blank";
        document.body.appendChild(form);
      }
      Object.keys(model).forEach(k => {
        let input = form[k];
        if (!input || typeof input !== "object") {
          // 当k是一些特殊字符串时，name id之类的 input类型应该是string
          input = document.createElement("input");
          input.type = "hidden";
          input.name = k;
          form.appendChild(input);
        }
        if (model[k] === undefined) {
          input.value = "";
        } else {
          input.value = (model[k]);
        }
      });
      form.submit();
    },
    $back(back = -1) {
      if (!isNaN(back)) {
        this.$router.go(back);
      } else {
        this.$router.go(-1);
      }
    },
    $beforeGoBack(md5, model, check) {
      return new Promise(resolve => {
        if (
          this.userInfo &&
          this.userInfo.id &&
          md5 &&
          this.$md5(model) !== md5 &&
          check
        ) {
          this.$confirm("存在未保存内容，是否进行保存后退出？", "返回", {
            type: "warning",
            showClose: false,
            confirmButtonText: "保存",
            cancelButtonText: "退出",
            closeOnClickModal: false
          })
            .then(() => {
              resolve(true);
            })
            .catch(() => {
              resolve(false);
            });
          return;
        }
        resolve(false);
      });
    },
    $beforeRouteChange(md5, model, check = true, opts = {}) {
      return new Promise(resolve => {
        this.$nextTick(() => {
          if (
            this.userInfo &&
            this.userInfo.id &&
            md5 &&
            this.$md5(model) !== md5 &&
            check
          ) {
            this.$confirm("存在未保存内容，是否进行保存后退出？", "返回", {
              type: "warning",
              showClose: false,
              confirmButtonText: "保存",
              cancelButtonText: "退出",
              closeOnClickModal: false,
              ...opts
            })
              .then(() => {
                resolve(false);
              })
              .catch(() => {
                resolve(true);
              });
            return;
          }
          resolve(true);
        });
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/mixins/index.js